import React from 'react';
import './Acces.css';
import teacher from '../../asserts/images/enseignant.jpg';
import etd from '../../asserts/images/campus.jpg';
import Entreprises from '../../asserts/images/eq.png';
import admin from '../../asserts/images/bureau.png';
import { Footer , Header} from '../index';
import { Link } from 'react-router-dom';


function Acces(props) {
  return (
    <>
    <Header/>
      
    <div className='containerAC'>
        <div className='bgAC'>  </div>
        <div className='ligne'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-287px', marginBottom: '300px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'70px'}}className="container-fluid text-white text-center ">Espace Extranet</h1>
          </div>
      </div>

      <div className="row row-cols-1 row-cols-md-2 g-4 " style={{ marginLeft: '100px', marginRight: '100px', marginTop: '-90px', marginBottom: '100px'  , minHeight:'120vh' }}>
      <div className="col accescard" >
      <div className="card w-100 rotate-card-y " onMouseEnter={(e) => e.currentTarget.classList.add('hovered')} onMouseLeave={(e) => e.currentTarget.classList.remove('hovered')}>
          {/* Face avant de la carte */}
          <div className="sides sides--fronts">
            <img src={teacher} style={{ width: '100%', height: '400px', filter: 'brightness(80%)' ,borderRadius:'5px'}} alt="Enseignant" />
            <div className="position-absolute top-50 start-50 translate-middle">
              <h5 style={{ color: 'white', fontSize: '30px', fontFamily: 'fantasy' }}  className="card-title container-fluid text-white text-center ">Espace Enseignant</h5>
            </div>
          </div>

          {/* Face arrière de la carte */}
          <div className="sides sides--back">
            <div className="back-buttons-y">
            <Link to="/Formulaires"  style={{marginTop:'-200px'}}><button>Cliquer ici</button></Link>
            <p className="titrecard container-fluid text-white text-center " style={{fontSize:'20px'}}>ISIMM Enseignant</p>
            </div>
          </div>
        </div>
        </div>
        <div className="col accescard">
          <div className="card w-100 rotate-card-y" onMouseEnter={(e) => e.currentTarget.classList.add('hovered')} onMouseLeave={(e) => e.currentTarget.classList.remove('hovered')}>
                      {/* Face avant de la carte */}
          <div className="sides sides--fronts">
           <img src={etd} style={{ width: '100%', height: '400px', filter: 'brightness(80%)',borderRadius:'5px' }} alt="Etudiant" />
            <div className="position-absolute top-50 start-50 translate-middle">
              <h5 style={{ color: 'white', fontSize: '30px', fontFamily: 'fantasy' }} className="card-title container-fluid text-white text-center ">Espace Etudiant</h5>
            </div>
          </div>

          {/* Face arrière de la carte */}
          <div className="sides sides--back">
            <div className="back-buttons-y">
            <Link to="/Formulaires"  style={{marginTop:'-200px'}}><button>Cliquer ici</button></Link>
              <p className="titrecard container-fluid text-white text-center " style={{fontSize:'20px'}}>ISIMM Etudiant</p>
            </div>
          </div>
          </div>
        </div>
        <div className="col accescard">
          <div className="card w-100 rotate-card-y" onMouseEnter={(e) => e.currentTarget.classList.add('hovered')} onMouseLeave={(e) => e.currentTarget.classList.remove('hovered')}>
            <div className="sides sides--fronts">
            <img src={admin} style={{ width: '100%', height: '400px', filter: 'brightness(80%)' ,borderRadius:'5px'}} alt="Administration" />
            <div className="position-absolute top-50 start-50 translate-middle">
              <h5 style={{ color: 'white', fontSize: '30px', fontFamily: 'fantasy' }} className="card-title container-fluid text-white text-center ">Espace Administration</h5>
            </div>
          </div>

          {/* Face arrière de la carte */}
          <div className="sides sides--back">
            <div className="back-buttons-y">
            <Link to="/Formulaires"  style={{marginTop:'-200px'}}><button>Cliquer ici</button></Link>
              <p className="titrecard container-fluid text-white text-center " style={{fontSize:'20px'}}>ISIMM Administration</p>
            </div>
          </div>
          </div>
        </div>
        <div className="col accescard">
          <div className="card w-100 rotate-card-y" onMouseEnter={(e) => e.currentTarget.classList.add('hovered')} onMouseLeave={(e) => e.currentTarget.classList.remove('hovered')}>
            <div className="sides sides--fronts">
            <img src={Entreprises} style={{ width: '100%', height: '400px', filter: 'brightness(80%)',borderRadius:'5px' }} alt="Entreprises" />
            <div className="position-absolute top-50 start-50 translate-middle">
              <h5 style={{ color: 'white', fontSize: '30px', fontFamily: 'fantasy' }} className="card-title container-fluid text-white text-center ">Espace Entreprises</h5>
            </div>
          </div>

          {/* Face arrière de la carte */}
          <div className="sides sides--back">
            <div className="back-buttons-y">
            <Link to="/Formulaires" style={{marginTop:'-200px'}}><button>Cliquer ici</button></Link>
              <p className="titrecard container-fluid text-white text-center " style={{fontSize:'20px'}}>ISIMM Entreprises</p>
            </div>
          </div>
          </div>
        </div>
      </div>

      <Footer/>
    </>
  );
}

export default Acces;